import { Baselayer } from "src/types";

export const baselayers: Baselayer[] = [
  {
    // OpenStreetMap_Mapnik
    key: "street-map",
    translationKey: "layer.openStreetMap",
    description: "",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: "&#169;<a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors",
    image: "images/map-preview/street-map@2x.png",
    isActive: true,
  },
  // // {
  // //   key: 'grb',
  //   title: 'GRB',
  //   url:
  //     'http://tile.informatievlaanderen.be/ws/raadpleegdiensten/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=grb_bsk&STYLE=&FORMAT=image/png&TILEMATRIXSET=GoogleMapsVL&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
  //   attribution: '',
  //   image:
  //     'https://mapbase.marvin.vito.be/configurations/spaarbekkens/images/map-preview/GRB.png',
  //   isActive: false,
  // },
  // {
  //   key: 'grb-grijs',
  //   title: 'Basiskaart - GRB grijs',
  //   url:
  //     'http://tile.informatievlaanderen.be/ws/raadpleegdiensten/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=grb_bsk_grijs&STYLE=&FORMAT=image/png&TILEMATRIXSET=GoogleMapsVL&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
  //   attribution: '',
  //   image:
  //     'https://mapbase.marvin.vito.be/configurations/spaarbekkens/images/map-preview/GRB_grijs.png',
  //   isActive: false,
  // },
  // {
  //   // OpenStreetMap_BlackAndWhite
  //   key: "black-white",
  //   translationKey: "grayscaleMap",
  //   description: "",
  //   url: "http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png",
  //   attribution: "&#169;<a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors",
  //   image: "images/map-preview/black-white@2x.png",
  //   isActive: false,
  // },
  {
    // Esri_WorldImagery
    key: "world-imagery",
    translationKey: "layer.satelliteMap",
    description: "Esri",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution:
      "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
    image: "images/map-preview/world-imagery@2x.png",
    isActive: false,
  },
  {
    // cartoDB
    key: "low-contrast",
    translationKey: "layer.lowContrastMap",
    description: "CartoDB",
    url: "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png",
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
    image: "images/map-preview/low-contrast@2x.png",
    isActive: false,
  },
];
